import FeedbackHabits from './FeedbackHabits'
import FeedbackNotAlone from './FeedbackNotAlone'
import FeedbackPowerful from './FeedbackPowerful'
import FeedbackProgress from './FeedbackProgress'
import QuestionAffectsSkin from './QuestionAffectsSkin'
import QuestionAge from './QuestionAge'
import QuestionDifferentThisTime from './QuestionDifferentThisTime'
import QuestionExperience from './QuestionExperience'
import QuestionFeelYourSkin from './QuestionFeelYourSkin'
import QuestionGender from './QuestionGender'
import QuestionGoal from './QuestionGoal'
import QuestionHeldYourBack from './QuestionHeldYourBack'
import QuestionSkinBest from './QuestionSkinBest'
import QuestionSkinBudget from './QuestionSkinBudget'
import QuestionSkinConcern from './QuestionSkinConcern'
import QuestionSkinTime from './QuestionSkinTime'
import QuestionSkinWouldBetter from './QuestionSkinWouldBetter'
import QuestionSleep from './QuestionSleep'
import QuestionStress from './QuestionStress'
import QuestionSunExposure from './QuestionSunExposure'
import QuestionWater from './QuestionWater'
import RatingGrateful from './RatingGrateful'

import navigateToNextOnboardingPageAction from '@actions/navigateToNextOnboardingPageAction'

const onboardingRoutes = [
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionGender />,
    path: 'question-feel-your-skin',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionFeelYourSkin />,
    path: 'question-feel-your-skin-2',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionSkinWouldBetter />,
    path: 'question-skin-would-better',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <FeedbackNotAlone />,
    path: 'feedback-not-alone',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionHeldYourBack />,
    path: 'question-held-your-back',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionDifferentThisTime />,
    path: 'question-different-this-time',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <RatingGrateful />,
    path: 'rating-grateful',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionGoal />,
    path: 'question-goal',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionAffectsSkin />,
    path: 'question-affects-skin',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionSkinBest />,
    path: 'question-skin-best',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionAge />,
    path: 'question-age',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionExperience />,
    path: 'question-experience',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <FeedbackProgress />,
    path: 'feedback-progress',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionSkinConcern />,
    path: 'question-skin-concern',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionSleep />,
    path: 'question-sleep',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionWater />,
    path: 'question-water',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <FeedbackHabits />,
    path: 'feedback-habits',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionStress />,
    path: 'question-stress',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionSunExposure />,
    path: 'question-sun-exposure',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionSkinBudget />,
    path: 'question-skin-budget',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <QuestionSkinTime />,
    path: 'question-skin-time',
  },
  {
    action: navigateToNextOnboardingPageAction,
    element: <FeedbackPowerful />,
    path: 'feedback-powerful',
  },
]

export default onboardingRoutes
